import { useQuery } from "@tanstack/react-query";
import httpClient from "../httpClient";
import { ThemeProps } from "../../models/theme";
import { ErrorResponse } from "../../models/apiResponse";

const useQueryTheme = ({
  corporateName,
  enabled = true,
  authorisation = "",
}: {
  corporateName: string;
  enabled?: boolean;
  authorisation?: string;
}) => {
  return useQuery(
    ["theme"],
    () =>
      httpClient(`theme/by-url/${corporateName}`, {
        authorisation,
      }).get<ThemeProps | ErrorResponse>(),
    {
      staleTime: 1000 * 60 * 10,
      refetchOnWindowFocus: false,
      enabled,
    }
  );
};

export default useQueryTheme;
